import { createSlice } from "@reduxjs/toolkit";

const changeLogExcelDataSlice = createSlice({
  name: "changeLogExcelData",
  initialState: {
    drmExcelTableData: {
      onPage: 0,
      pageSize: 0,
      drmMaintenanceDetails: [],
      totalPages: 0,
      totalRecords: 0,
    },
    isLoading: false,
    errorMessage: undefined,
  },
  reducers: {
    getChangeLogExcelTableData: (state) => {
      state.isLoading = true;
      state.drmExcelTableData.drmMaintenanceDetails = [];
    },
    setChangeLogExcelTableDataSuccess: (state, action) => {
      state.isLoading = false;
      state.drmExcelTableData = action.payload;
    },
    setChangeLogExcelTableDataFailure: (state, action) => {
      state.isLoading = false;
      state.drmExcelTableData = {
        onPage: 0,
        pageSize: 0,
        drmMaintenanceDetails: [],
        totalPages: 0,
        totalRecords: 0,
      };
      state.errorMessage = action.payload;
    },
    resetChangeLogExcelTableData: (state) => {
      state.isLoading = false;
      state.drmExcelTableData = {
        onPage: 0,
        pageSize: 0,
        drmMaintenanceDetails: [],
        totalPages: 0,
        totalRecords: 0,
      };
    },
  },
});

export const {
  getChangeLogExcelTableData,
  setChangeLogExcelTableDataSuccess,
  setChangeLogExcelTableDataFailure,
  resetChangeLogExcelTableData,
} = changeLogExcelDataSlice.actions;

export default changeLogExcelDataSlice.reducer;
